import { GET_REPORT_IP_REQUEST, GET_REPORT_IP_SUCCESS, GET_REPORT_IP_ERROR } from "./types";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getReportIP = (token) => (dispatch) => {
    dispatch({ type: GET_REPORT_IP_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/reportURL`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },

    })
        .then((response) => {
            return dispatch({ type: GET_REPORT_IP_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_REPORT_IP_ERROR,
                payload: error.response,
            });
        });
};